import React, { lazy } from 'react';
import { PhoneIcon, MailIcon, MessageCircleIcon, ClockIcon, MapPinIcon } from 'lucide-react';
import { Typography } from '@mui/material';
const SupportPage: React.FC = () => {
  return <div className="p-6 bg-gray-50 min-h-screen" data-id="element-2691">
      <div className="flex items-center gap-3 mb-6" data-id="element-2692">
        <MessageCircleIcon className="h-7 w-7" color="#0052CC" data-id="element-2693" />
        <Typography variant="h4" sx={{
        fontWeight: 700,
        color: '#0052CC'
      }} data-id="element-2694">
          Support
        </Typography>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-2695">
        <div className="bg-white rounded-lg shadow p-6" data-id="element-2696">
          <div className="flex items-center mb-4" data-id="element-2697">
            <div className="p-3 rounded-full bg-blue-100 text-blue-600 mr-4" data-id="element-2698">
              <PhoneIcon className="h-6 w-6" data-id="element-2699" />
            </div>
            <div data-id="element-2700">
              <h2 className="text-lg font-medium text-gray-800" data-id="element-2701">
                24/7 Helpline
              </h2>
              <p className="text-gray-600" data-id="element-2702">
                Our support team is available around the clock
              </p>
            </div>
          </div>
          <div className="ml-16" data-id="element-2703">
            <a href="tel:+922134812068" className="text-xl font-medium text-blue-600 hover:text-blue-800" data-id="element-2704">
              021-34812068
            </a>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6" data-id="element-2705">
          <div className="flex items-center mb-4" data-id="element-2706">
            <div className="p-3 rounded-full bg-green-100 text-green-600 mr-4" data-id="element-2707">
              <MailIcon className="h-6 w-6" data-id="element-2708" />
            </div>
            <div data-id="element-2709">
              <h2 className="text-lg font-medium text-gray-800" data-id="element-2710">
                Email Support
              </h2>
              <p className="text-gray-600" data-id="element-2711">
                Send us an email for any inquiries
              </p>
            </div>
          </div>
          <div className="ml-16" data-id="element-2712">
            <a href="mailto:ops@paysyslabs.com" className="text-xl font-medium text-green-600 hover:text-green-800" data-id="element-2713">
              ops@paysyslabs.com
            </a>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6" data-id="element-2714">
          <div className="flex items-center mb-4" data-id="element-2715">
            <div className="p-3 rounded-full bg-purple-100 text-purple-600 mr-4" data-id="element-2716">
              <MessageCircleIcon className="h-6 w-6" data-id="element-2717" />
            </div>
            <div data-id="element-2718">
              <h2 className="text-lg font-medium text-gray-800" data-id="element-2719">
                WhatsApp Support
              </h2>
              <p className="text-gray-600" data-id="element-2720">Get instant help via WhatsApp</p>
            </div>
          </div>
          <div className="ml-16" data-id="element-2721">
            <a href="https://wa.me/923132370605" target="_blank" rel="noopener noreferrer" className="text-xl font-medium text-purple-600 hover:text-purple-800" data-id="element-2722">
              +92-313-2370605
            </a>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6" data-id="element-2723">
          <div className="flex items-center mb-4" data-id="element-2724">
            <div className="p-3 rounded-full bg-yellow-100 text-yellow-600 mr-4" data-id="element-2725">
              <ClockIcon className="h-6 w-6" data-id="element-2726" />
            </div>
            <div data-id="element-2727">
              <h2 className="text-lg font-medium text-gray-800" data-id="element-2728">
                Support Hours
              </h2>
              <p className="text-gray-600" data-id="element-2729">
                Our support team is available 24/7
              </p>
            </div>
          </div>
          <div className="ml-16" data-id="element-2730">
            <p className="text-gray-700" data-id="element-2731">
              <span className="font-medium" data-id="element-2732">Monday - Sunday:</span> 24 hours
            </p>
            <p className="text-gray-700 mt-1" data-id="element-2733">
              <span className="font-medium" data-id="element-2734">Holidays:</span> 24 hours
            </p>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow p-6" data-id="element-2735">
        <div className="flex items-center mb-6" data-id="element-2736">
          <div className="p-3 rounded-full bg-red-100 text-red-600 mr-4" data-id="element-2737">
            <MapPinIcon className="h-6 w-6" data-id="element-2738" />
          </div>
          <div data-id="element-2739">
            <h2 className="text-lg font-medium text-gray-800" data-id="element-2740">Head Office</h2>
            <p className="text-gray-600" data-id="element-2741">Visit our main office location</p>
          </div>
        </div>
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-2742">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3619.5498293553193!2d67.0340397!3d24.8730915!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e70a31f45a9%3A0x25e252450977c668!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1651234567890!5m2!1sen!2s" width="100%" height="300" style={{
          border: 0
        }} allowFullScreen={false} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Office Location" data-id="element-2743"></iframe>
        </div>
        <div className="mt-4 text-gray-700" data-id="element-2744">
          <p className="mb-2" data-id="element-2745">
            <strong data-id="element-2746">Address:</strong> Office #123, Business Plaza,
            Shahrah-e-Faisal, Karachi, Pakistan
          </p>
          <p data-id="element-2747">
            <strong data-id="element-2748">Phone:</strong> 021-34812068
          </p>
        </div>
      </div>
      <div className="mt-6 bg-white rounded-lg shadow p-6" data-id="element-2749">
        <h2 className="text-lg font-medium text-gray-800 mb-4" data-id="element-2750">
          Frequently Asked Questions
        </h2>
        <div className="space-y-4" data-id="element-2751">
          <div className="border border-gray-200 rounded-lg p-4" data-id="element-2752">
            <h3 className="text-md font-medium text-gray-700 mb-2" data-id="element-2753">
              How can I track my remittance?
            </h3>
            <p className="text-gray-600" data-id="element-2754">
              You can track your remittance by entering the transaction
              reference number in the Transaction History section.
            </p>
          </div>
          <div className="border border-gray-200 rounded-lg p-4" data-id="element-2755">
            <h3 className="text-md font-medium text-gray-700 mb-2" data-id="element-2756">
              What do I do if a transaction is rejected?
            </h3>
            <p className="text-gray-600" data-id="element-2757">
              If a transaction is rejected, you will receive a notification with
              the reason. You can contact our support team for assistance.
            </p>
          </div>
          <div className="border border-gray-200 rounded-lg p-4" data-id="element-2758">
            <h3 className="text-md font-medium text-gray-700 mb-2" data-id="element-2759">
              How long does it take to process a remittance?
            </h3>
            <p className="text-gray-600" data-id="element-2760">
              Most remittances are processed within minutes. However, some
              transactions may take up to 24 hours depending on the destination
              country and payment method.
            </p>
          </div>
          <div className="border border-gray-200 rounded-lg p-4" data-id="element-2761">
            <h3 className="text-md font-medium text-gray-700 mb-2" data-id="element-2762">
              Can I cancel a remittance after it's been sent?
            </h3>
            <p className="text-gray-600" data-id="element-2763">
              You can request cancellation if the transaction has not been paid
              out yet. Please contact our support team immediately.
            </p>
          </div>
        </div>
      </div>
    </div>;
};
export default SupportPage;